import { useQuery } from '@apollo/client';
import { SCHEDULE_QUERY, type ScheduleQueryData, type ScheduleQueryVars } from '../queries';
import { useAuth } from 'components/Auth';

export const useScheduleQuery = (skip = false) => {
    const { effectiveProviderData } = useAuth();
    
    return useQuery<ScheduleQueryData, ScheduleQueryVars>(
        SCHEDULE_QUERY,
        {
            fetchPolicy: 'network-only',
            variables: {
                providerId: effectiveProviderData?.providerId ?? 0
            },
            skip
        }
    );
}